import { render } from "./ApartmentsPendingApprovalsItems.vue?vue&type=template&id=522c7b2f"
import script from "./ApartmentsPendingApprovalsItems.vue?vue&type=script&lang=js"
export * from "./ApartmentsPendingApprovalsItems.vue?vue&type=script&lang=js"

import exportComponent from "/home/deployuser/prod/immivo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__